export default __webpack_public_path__ + "static/media/ux-ui-design.8d27a70c.svg";